<template>
  <div class="container">
    <generic-table
      ref="datatable"
      :title="$t('reports')"
      :columns="columns"
      :column_search="true"
      mode="grid"
      page_length="25"
      resource_url="/report/datatables"
    >
      <template v-slot:buttons>
        <!-- <button class="button is-secondary is-rounded" @click="manage">
          <span class="icon"><i class="fa fa-list"></i></span>
          <span>{{ $t("manage") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button> -->
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <!-- <div class="controls">
              <div
                class="is-pulled-right has-text-danger"
                :data-tooltip="$t('delete')"
                @click="remove(item)"
              >
                <span class="icon"><i class="fa fa-trash"></i></span>
              </div>
              <div
                class="is-pulled-right has-text-warning"
                :data-tooltip="$t('details')"
                @click="details(item)"
              >
                <span class="icon"><i class="fa fa-info"></i></span>
              </div>
            </div> -->

            <!-- <div
              class="is-pulled-right has-text-info"
              :data-tooltip="$t('download')"
              @click="download(item)"
            >
              <span class="icon"><i class="fa fa-download"></i></span>
            </div> -->

            <figure
              class="image is-64x64 m-auto"
              @click="show_report(item)"
              :data-tooltip="$t('show report')"
            >
              <img :src="item.settings.icon" />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t(item.name) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </generic-table>
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  error_message,
  format_date_time,
  format_currency,
} from "@/utils";
import router from "@/router";

export default {
  name: "ReportsDatatable",
  components: { GenericTable },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          width: "75%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.$t(row.name) || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  get("/report", { uuid })
                    .then((report) => {
                      v.execute_report(report);
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              },
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("delete"),
              //   icon: "fa fa-trash",
              //   icon_class: "is-small has-text-danger",
              //   click: (e) => {
              //     let uuid = e.detail.uuid;
              //     confirm_deletion_dialog(
              //       v.$t("are you sure to delete bill?"),
              //       v,
              //       () => {
              //         del("/fel/bill", { uuid: uuid })
              //           .then(() => {
              //             v.refresh();
              //           })
              //           .catch((error) => {
              //             error_message(error);
              //           });
              //       }
              //     );
              //   },
              // },
            ]);
          },
        },
      ],
      reports: [],
    };
  },
  methods: {
    format_date_time,
    format_currency,
    create() {
      let v = this;
      v.$refs.report_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    // init_complete(opts) {
    //   let v = this;
    //   let { settings, json } = opts;
    //   let layout_table = window.jQuery(".dt-layout-table");
    //   // layout_table.addClass("is-hidden");
    // },
    // draw_as_list(json) {
    //   let v = this;
    //   // console.log("draw", json);
    //   v.reports = json;
    // },
    manage() {
      let v = this;
      v.$router.push({ path: "/report/manage" });
    },
    delete_report(report) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete report?"), v, () => {
        del("/report", { uuid: report.uuid })
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    execute_report(report) {
      // let v = this;
      // console.log("report", report);
      var Component = require(`../../reports/${report.settings.report_path}/Index.vue`);
      let rte = {
        path: "/report/:id",
        component: Component.default,
        meta: {
          title: report.name,
        },
      };
      let rt = router.addRoute(rte);
      router.push({
        path: `/report/${report.uuid}`,
      });

      /** Deletes the just-created route */
      rt();
    },
    show_report(report) {
      let v = this;
      get("/report", { uuid: report.uuid })
        .then((rpt) => {
          v.execute_report(rpt);
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
